import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { history } from "./helpers/history";
import { connect } from "react-redux";
import { ProvideBrowserOptions } from "./system/BrowserAgent/ProvideBrowserOptions";
import PresenterLayout from "./interaction/presenter/Layout/PresenterLayout";
import { SplashScreen } from "./components/SplashScreen/SplashScreen";
import ModeratorLayout from "./interaction/moderator/Layout/ModeratorLayout";
import StageLayout from "./interaction/stage/Layout/StageLayout";
import ExpoBoothLayout from "./exhibitor/ExpoBooth/Layout/ExpoBoothLayout";
import RedirectUser from "./RedirectUser";
import ChatModeratorLayout from "./interaction/chatModerator/Layout/ChatModeratorLayout";
import EditorWrapper from "./meetingEditor/layout/EditorWrapper";
import { Backoffice } from "./exhibitor2/Backoffice/Backoffice";
import VonageBackstage from "./vonageBackstage/VonageBackstage";
import VonageVideoWall from "./presentation/VideoWall/VonageVideoWall";
import ChannelList from "./interaction/channellist/ChannelList";
import PlauditPresenter from "./presentation/Plaudit/PlauditPresenter";

import "./App.scss";

const DigitalArena = React.lazy(() => import("./digitalArena/DigitalArena"));

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

class App extends Component {
  directToInadraHomePage = () => {
    window.location.replace("https://web.jirango.com");
  };
  render() {
    return (
      <Router history={history}>
        <React.Suspense fallback={loading()}>
          {this.props.globals.isLoading ? <SplashScreen /> : null}
          <Switch>
            <Route exact path="/react" name="Redirect to react" render={(props) => <RedirectUser {...props} />} />
            <Route exact path="/backstage/:id" name="Error page" render={(props) => <VonageBackstage {...props} />} />
            <Route exact path="/videowall/:id" render={(props) => <VonageVideoWall {...props} />} />
            <Route exact path="/plaudit/:id" render={(props) => <PlauditPresenter {...props} />} />
            <Route exact path="/digitalarena/:id" name="Digital Arena" render={(props) => <DigitalArena {...props} />} />
            <Route exact path="/digitalarena/mobile/:id" name="Digital Arena" render={(props) => <DigitalArena {...{ ...props, mobile: true }} />} />
            <Route exact path="/editor/:id" name="Digital meeting demo" render={(props) => <EditorWrapper {...props} />} />
            <Route exact path="/booth/:id" name="Digital meeting demo" render={(props) => <ExpoBoothLayout {...props} />} />
            <Route exact path="/login" name="Login Page" render={(props) => <ExternalRedirect exact={true} path={"/login"} link={"https://jirango.com/admin"} />} />
            <Route exact path="/404" name="Page 404" render={(props) => <h1>404</h1>} />
            <Route exact path="/provide-browser-options" name="Select Browser" render={(props) => <ProvideBrowserOptions {...props} />} />
            <Route exact path="/500" name="Page 500" render={(props) => <h1>500</h1>} />
            <Route exact path="/exhibitor/:id" name="Exhibitor Admin" render={(props) => <Backoffice {...props} />} />
            <Route exact path={"/session/chatmoderator/:id"} name="Client Controller" render={(props) => <ChatModeratorLayout {...props} />} />
            <Route exact path={"/presenter/:id"} name="Client Controller" render={(props) => <PresenterLayout {...props} />} />
            <Route exact path={"/session/stage/:id"} name="Stage Controller" render={(props) => <StageLayout {...props} />} />
            <Route exact path={"/channels/:id"} name="Channel List" render={(props) => <ChannelList {...props} />} />
            <Route
              exact
              path="/session/moderator/:id"
              name="Moderator Controller"
              render={(props) => (localStorage.getItem("user") ? <ModeratorLayout {...props} /> : <ExternalRedirect exact={true} path={"/session/moderator/:id"} link={"https://jirango.com/admin"} />)}
            />
            <Route path="/" name="Home" render={(props) => (localStorage.getItem("user") ? null : <ExternalRedirect exact={true} path={"/"} link={"https://web.jirango.com"} />)} />
          </Switch>
        </React.Suspense>
      </Router>
    );
  }
}
const ExternalRedirect = (props) => {
  const { link } = props;
  return (
    <Route
      render={() => {
        window.location.replace(props.link);
        return null;
      }}
    />
  );
};

function mapStateToProps(state) {
  return {
    globals: state.globals,
  };
}
export default connect(mapStateToProps)(App);
